import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "label"];

  declare readonly inputTarget: HTMLInputElement;
  declare readonly labelTarget: HTMLElement;

  updateLabel(): void {
    const { files } = this.inputTarget;

    if (!files || files.length === 0) {
      this.labelTarget.textContent = "Choose files";
    } else if (files.length === 1) {
      this.labelTarget.textContent = files[0].name;
    } else {
      this.labelTarget.textContent = `${files.length} files selected`;
    }
  }
}
